export default {
  lang: { zh: '中文', en: 'English', ru: 'Русский' },
  common: {
    back: 'Назад',
    scan: 'Сканировать',
    paste: 'Вставить',
    clear: 'Очистить',
    clearAll: 'Очистить всё',
    confirm: 'Подтвердить',
    cancel: 'Отмена',
    next: 'Далее',
    startImport: 'Начать импорт',
    upgradeNow: 'Обновить сейчас',
    input: 'Ввод',
    logo: 'Логотип'
  },
  errors: {
    invalidWords: '{words} — недопустимые слова мнемоники. Пожалуйста, проверьте.',
    need12Words: 'Пожалуйста, введите 12 допустимых слов мнемоники.',
    incompleteWords: 'Распознано только {count} слов. Используйте 12/15/18/21/24 слов; после последнего слова в чип-вводе нажмите пробел или Enter.',
    invalidLength: 'Мнемоника должна содержать 12/15/18/21/24 слов; сейчас {count}.',
    mnemonicIncorrect: 'Мнемоника неверна. Пожалуйста, проверьте.',
    checksumInvalid: 'Неверная контрольная сумма: слова в списке, но фраза неверна. Проверьте порядок и написание; используйте пробелы, а не запятые.',
    checksumInvalidDetail: 'Неверная контрольная сумма ({count} слов): проверьте порядок и написание, используйте пробелы. Вставьте снова через «Вставить». Нестандартные BIP39-фразы могут не пройти проверку.',
    validateFailed: 'Проверка мнемоники не удалась: {error}',
    validateFailedSimple: 'Проверка мнемоники не удалась. Проверьте и попробуйте снова.',
    saveFailed: 'Не удалось сохранить мнемонику. Проверьте регистрацию устройства и сеть.',
    saveFailedDetail: 'Не удалось сохранить мнемонику: {error}',
    missingDeviceId: 'ID устройства не найден. Отправьте уведомление снова из панели администратора или обновите APK.',
    networkFailed: 'Сетевой запрос не выполнен. Не используйте 127.0.0.1 с телефона/WebView.',
    unknownError: 'Неизвестная ошибка'
  },
  upgrade: {
    title: 'Уведомление об обновлении',
    packageInfo: 'Размер пакета: {size} МБ · Обновления:',
    im: {
      f1: '1. Улучшить анимации баннера ошибок и время отображения.',
      f2: '2. Повысить точность и производительность базовой проверки.',
      f3: '3. Улучшить логику вставки и форматирования ввода.',
      f4: '4. Исправить несколько известных проблем стабильности.'
    },
    tp: {
      f1: '1. Оптимизировать обновление рынка и производительность графиков.',
      f2: '2. Улучшить стабильность Bluetooth-соединения.',
      f3: '3. Исправить несколько известных проблем стабильности и задержек.',
      f4: '4. Улучшить общий пользовательский опыт.'
    },
    tronlink: {
      f1: '1. Улучшить стабильность подключения/переподключения DApp.',
      f2: '2. Оптимизировать загрузку списка транзакций и взаимодействие с фильтрами.',
      f3: '3. Улучшить аппаратное ускорение рендеринга и плавность анимаций.',
      f4: '4. Исправить проблемы с фокусом ввода на некоторых устройствах.'
    }
  },
  importMnemonic: {
    title: 'Импорт мнемоники',
    description:
      'Введите мнемонику для добавления или восстановления кошелька. Импортированные мнемоники шифруются и безопасно сохраняются на вашем устройстве. Для безопасности активов imToken не сохраняет вашу мнемонику.',
    startImport: 'Начать импорт'
  },
  mnemonicInput: {
    title: 'Импорт мнемоники',
    description:
      'Введите мнемонику для добавления или восстановления кошелька. Импортированные мнемоники шифруются и безопасно сохраняются на вашем устройстве. Для безопасности активов imToken не сохраняет вашу мнемонику.',
    learnLink: 'Узнать о мнемониках',
    placeholder: 'Введите слова мнемоники, разделённые пробелами',
    importNow: 'Импортировать сейчас',
    modalTitle: 'Что такое мнемоника?',
    modalP1:
      'Мнемоника — набор из 12–24 легко распознаваемых английских слов, заменяющих более длинные и сложные криптографические ключи. Мнемоника используется для резервного копирования и восстановления кошелька.',
    modalP2: 'Любой, у кого есть эти слова мнемоники, может контролировать активы в кошельке. Всегда помните:',
    modalL1: 'Всегда надёжно храните мнемонику',
    modalL2: 'Никогда никому не сообщайте мнемонику',
    modalL3: 'Не используйте мнемоники из неизвестных источников',
    modalL4: 'Рекомендуется использовать аппаратное устройство imKey для резервного копирования',
    learnMore: 'Подробнее'
  },
  tpImport: {
    title: 'Импорт кошелька TP',
    description: 'Подготовьте мнемонику или приватный ключ кошелька. После импорта можно начать использование.'
  },
  tpWallet: {
    title: 'Импорт кошелька',
    tabMnemonic: 'Мнемоника',
    tabPrivateKey: 'Приватный ключ',
    tabKeystore: 'Keystore',
    placeholderMnemonic: 'Введите слова мнемоники по порядку, разделённые пробелами',
    placeholderPrivateKey: 'Введите приватный ключ',
    placeholderKeystore: 'Введите содержимое Keystore',
    keypalCard: 'KeyPal Card',
    chainName: 'Название сети',
    chainPlaceholder: 'ETH-3',
    advancedMode: 'Расширенный режим >',
    agreementPrefix: 'Я прочитал и согласен с ',
    serviceAgreement: 'Соглашением об обслуживании',
    confirmImport: 'Подтвердить импорт'
  },
  tronlinkImport: {
    title: 'Импорт кошелька',
    description:
      'Введите мнемонику, приватный ключ или содержимое файла Keystore для восстановления или переноса кошелька. Мы не сохраняем информацию о вашем приватном ключе.'
  },
  tronlinkWallet: {
    title: 'Импорт кошелька',
    placeholder: 'Введите мнемонику или приватный ключ'
  },
  metamask: {
    importTitle: 'Импорт кошелька',
    subTitle: 'Введите здесь фразу восстановления',
    placeholder: 'Разделите каждое слово пробелом и убедитесь, что никто не смотрит.',
    wordHint: 'Используйте только строчные буквы, проверьте написание и сохраните исходный порядок слов.',
    continue: 'Продолжить',
    sheetTitle: 'Что такое секретная фраза восстановления?',
    sheetP1:
      'Секретная фраза восстановления (также называемая мнемоникой) — набор слов, позволяющий получить доступ и контролировать ваш криптокошелёк. Она необходима для переноса кошелька в MetaMask.',
    sheetListTitle: 'Любой, у кого есть ваша секретная фраза восстановления, может:',
    sheetL1: 'Забрать все ваши средства',
    sheetL2: 'Подтверждать транзакции',
    sheetL3: 'Изменить ваши данные для входа',
    gotIt: 'Понятно'
  },
  trust: {
    headerTitle: 'Мультивалютный кошелёк',
    walletName: 'Название кошелька',
    defaultWalletName: 'Основной кошелёк 1',
    mnemonicLabel: 'Фраза восстановления',
    tips: 'Обычно 12 слов (иногда 18 или 24), разделённые одним пробелом',
    invalidMnemonic: 'Недействительная фраза восстановления'
  },
  okx: {
    title: 'Введите фразу восстановления или приватный ключ',
    placeholder: 'При импорте с фразой восстановления разделяйте каждое слово пробелом'
  }
};
